/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMenuAdvanced = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 3v18H2V3zm-2 2H4v14h16zM8 15v2H6v-2zm10 0v2h-8v-2zM8 11v2H6v-2zm10 0v2h-8v-2zM8 7v2H6V7zm10 0v2h-8V7z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMenuAdvanced as MenuAdvanced };
